const getDataLength = (data) => {
  return Object.values(data).reduce((acc, value) => acc + value.length, 0);
};

export default getDataLength;
